<template lang="pug">
.monitor-viewer-dashboard
  .dashboard-header
    h1 监控查看中心
    .user-info
      span 欢迎，{{ userInfo.name || userInfo.username }}
      ui-button(@click='handleLogout', type='text') 退出登录

  .projects-container
    h2 可查看的项目
    .projects-grid(v-if='projects.length')
      .project-card(
        v-for='project in projects',
        :key='project.id',
        @click='viewProjectCams(project)'
      )
        .project-title {{ project.title }}
        .project-description {{ project.description || '暂无描述' }}
        .project-actions
          ui-button(type='primary', size='small') 查看监控
    .empty-state(v-else)
      p 暂无可查看的项目
      p 请联系管理员分配项目权限
</template>

<script>
import { _ } from '@yishitec/web';

export default {
  name: 'MonitorViewerDashboard',
  data() {
    return {
      userInfo: {},
      projects: [],
      loading: false,
    };
  },
  async mounted() {
    await this.loadUserInfo();
    await this.loadProjects();
  },
  methods: {
    async loadUserInfo() {
      try {
        this.userInfo = await this.api('/api/monitor-viewer/me')();
        // 检查是否返回未登录消息
        if (this.userInfo.message === '未登录') {
          this.$router.push('/monitor-viewer/login');
          return;
        }
      } catch (e) {
        // this.$message.error('获取用户信息失败');
        this.$router.push('/monitor-viewer/login');
      }
    },

    async loadProjects() {
      try {
        this.loading = true;
        this.projects = await this.api('/api/monitor-viewer/projects')();
      } catch (e) {
        this.$message.error('获取项目列表失败');
        this.projects = [];
      } finally {
        this.loading = false;
      }
    },

    viewProjectCams(project) {
      this.$router.push(`/monitor-viewer/project/${project.id}/cams`);
    },

    async handleLogout() {
      try {
        await this.api('/api/monitor-viewer/logout')();
        this.$router.push('/monitor-viewer/login');
      } catch (e) {
        this.$message.error('退出登录失败');
      }
    },
  },
};
</script>

<style lang="less" scoped>
.monitor-viewer-dashboard {
  min-height: 100vh;
  background: #f5f5f5;
  padding: 20px;
}

.dashboard-header {
  background: white;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  h1 {
    margin: 0;
    color: #333;
    font-size: 24px;
  }

  .user-info {
    display: flex;
    align-items: center;
    gap: 15px;

    span {
      color: #666;
    }
  }
}

.projects-container {
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  h2 {
    margin: 0 0 20px 0;
    color: #333;
    font-size: 18px;
  }
}

.projects-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
}

.project-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: white;

  &:hover {
    border-color: #409eff;
    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.15);
    transform: translateY(-2px);
  }

  .project-title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin-bottom: 8px;
  }

  .project-description {
    color: #666;
    font-size: 14px;
    margin-bottom: 15px;
    line-height: 1.4;
  }

  .project-actions {
    text-align: right;
  }
}

.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #999;

  p {
    margin: 10px 0;
    font-size: 14px;
  }
}
</style>
